skrilla.controller('matchesModalCtrl', function ($scope, searchService, cacheService, dateService, modalService, queryService) {
    var dismissAll = function(){
        modalService.dismissAll();
    }
    $scope.sport = cacheService.getObjectOrElse("contestSport", dismissAll);
    $scope.matchSelected = cacheService.getObjectOrElse("matchesModalFunction", dismissAll);


    $scope.getDate = dateService.getUTC;
    $scope.selectedMatches = [];
    $scope.seasons = []
    $scope.date = new Date();
    $scope.date.setHours(0, 0, 0, 0);


    $scope.search = function() {
        $scope.tomorrow = new Date($scope.date);
        $scope.tomorrow.setHours($scope.date.getHours() + 24);
        searchService.get("matches/" + queryService.getQueryString({sport: $scope.sport, afterDate:  $scope.date.toISOString(), beforeDate: $scope.tomorrow.toISOString()})).then(function (response) {
            $scope.seasons = response.data;
        });
    }

});